import { useContext } from 'react';
import { JurisdictionContext } from 'contexts/jurisdictionContext/JurisdictionContext';

export const useJurisdictionContext = () => {
	return useContext(JurisdictionContext);
};
